import { render, staticRenderFns } from "./FormularioDatosPropios.vue?vue&type=template&id=78c7b4b0&scoped=true&"
import script from "./FormularioDatosPropios.vue?vue&type=script&lang=js&"
export * from "./FormularioDatosPropios.vue?vue&type=script&lang=js&"
import style0 from "./FormularioDatosPropios.vue?vue&type=style&index=0&id=78c7b4b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c7b4b0",
  null
  
)

export default component.exports